export const DUE_AT_DELIVERY_MISMATCH = 1023;
export const RETAIL_MISMATCH = 1027;
export const PAYMENT_MISMATCH = 1036;
export const PAYMENT_TAXES_MISMATCH = 1042;
export const FINANCED_AMOUNT_MISMATCH = 1043;
export const FINANCED_AMOUNT_WITH_TAXES_MISMATCH = 1044;

export default {
    RETAIL_MISMATCH,
    PAYMENT_MISMATCH,
    PAYMENT_TAXES_MISMATCH,
    FINANCED_AMOUNT_MISMATCH,
    FINANCED_AMOUNT_WITH_TAXES_MISMATCH,
    DUE_AT_DELIVERY_MISMATCH,
};
